import React from "react";
import "./App.css";
import "./components/Header";
import Header from "./components/Header";
import Sidebar from "./components/Sidebar";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Chat from "./components/Chat";
import Login from "./components/Login";
import { useStateValue } from "./StateProvider";

function App() {
  const [{ user }, dispatch] = useStateValue();

  return (
    <div className="app">
      <Router>
        {/* Header */}
        {!user ? (
          <Login />
        ) : (
          <>
            <Header />

            <div className="app-body">
              {/* Sidebar */}
              <Sidebar />
              <Switch>
                <Route path="/login">
                  <Login />
                </Route>
                <Route path="/room/:roomId">
                  {/* <h1>CHAT SCREEN</h1> */}
                  <Chat />
                </Route>
                <Route path="/">
                  <div className="welcome">
                    <div className="welcome-message">
                      <h3>Welcome, {user?.displayName}!</h3>
                      <p>Thanks for joining this chat!</p>
                    </div>
                  </div>
                </Route>
                <Route path="/signout">
                  <div className="welcome">
                    <div className="welcome-message">
                      <h3>Bye, {user?.displayName}!</h3>
                      <p>You've signed out and can close this caht window</p>
                    </div>
                  </div>
                </Route>
              </Switch>

              {/* React Router for Chat Window */}
            </div>
          </>
        )}
      </Router>
    </div>
  );
}

export default App;
